import react from 'react'
import react_client from 'react-dom/client'

import { ChakraProvider, defaultSystem } from '@chakra-ui/react'


// eslint-disable-next-line @typescript-eslint/naming-convention
import Dialog from '@/components/ui/dialog.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Drawer from '@/components/ui/drawer.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Toast from '@/components/ui/toast.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Views from './views'

import '@/style/global.less'




let body = document.getElementsByTagName('body')[0]

react_client.createRoot(body)
	.render(
		<react.StrictMode>
			<ChakraProvider value={defaultSystem}>
				<Views />

				<Dialog />
				<Drawer />
				<Toast />

			</ChakraProvider>

		</react.StrictMode>,

	)

